import { gql } from "graphql-tag"

import countries from "./countries"
import labels from "./labels"
import storeLinks from "./storeLinks"
import stores from "./stores"
import vendors from "./vendors"

const vendorsTypeDefs = gql`
  ${countries}
  ${labels}
  ${storeLinks}
  ${stores}
  ${vendors}
`

export default vendorsTypeDefs
